/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 11/05/2018
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
controller('WebSiteCustomerPostCtrl',["$filter","$log","$scope","$rootScope","$routeParams","$location","$dialog","CustomerPostData","CustomerPostView","gettextCatalog","CompanyImageData","ConstantsCustomerPosts",
    function($filter,$log,$scope,$rootScope,$routeParams,$location,$dialog,CustomerPostData,CustomerPostView, gettextCatalog, CompanyImageData, ConstantsCustomerPosts) {

        $scope.dd = {
            displayPostMode : false,
            displayConfirmMessage : false,
            customersPostsDisplay: [],
            customersPostsNeedValidation: [],
            sortSelected : "rating.reverse",
            sort: "rating",
            sortReverse: true,
            averageNotation: 0,
            averageNotationDisplay: 0,
            nbActiveRating: 0,
            editedCustomerPostView : null,
            isWaitingForCallback : false,
            percent : {
                one : 0,
                two : 0,
                three : 0,
                four : 0,
                five : 0
            },
            nbRating : {
                one : 0,
                two : 0,
                three : 0,
                four : 0,
                five : 0
            },
            view: {
                postTitle: "",
                postMessage: "",
                postRate: 0,
                postImage : null
            },
            rating: {
                starsClass: []
            },
            flowConfig : {
                target: '/rest/companyImageUpload',
                method:'octet',
                query : {companyCode: $scope.ad.companyCode,type:'customer'},
                maxChunkRetries: 1,
                chunkSize:5*1024*1024,
                simultaneousUploads: 4,
                singleFile: true,
                testChunks:false,
                headers: {Authorization: $scope.ad.currentUser.token}
            },
            error : {
              display : false,
              message : ""
            },
            colors : ConstantsCustomerPosts,
            starYellowCssClass : "fa fa-star star-y",
            starGreyCssClass : "fa fa-star star",
        };
        $scope.redirectToHomeWhenAccessIsNotGranted();

        $scope.getCharColor = function(firstName){
            var color = $scope.dd.colors[$scope.getFirstLetterFirstName(firstName)];
            return color;
        }

        $scope.getFirstLetterFirstName = function(firstName){
            if(firstName != null)
                return firstName.charAt(0);
            else
                return "?";
        }

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                $scope.orderCustomersPost();
                $scope.initTabRating();
            }
        });

        $scope.initTabRating = function(){
            $scope.dd.rating.starsClass = [];
            $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
            $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
            $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
            $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
            $scope.dd.rating.starsClass.push($scope.dd.starGreyCssClass);
        }

        $scope.onSaveSuccess = function(){
            $scope.orderCustomersPost();
            $scope.clearPostView();
            $scope.dd.displayConfirmMessage = true;
            $scope.dd.displayPostMode = false;
        };

        $scope.saveCustomerPost = function () {
            $scope.dd.isWaitingForCallback = true;

            var cpView = new CustomerPostView(null, -1);
            cpView.companyImage = $scope.dd.view.postImage;
            cpView.customer = $scope.ad.view.customerView.getModel();
            cpView.rating = $scope.dd.view.postRate;
            cpView.customerAuthPublish = true;
            cpView.timeCreated = new Date();
            cpView.text = $scope.dd.view.postMessage;
            cpView.title = $scope.dd.view.postTitle;

            if($scope.ad.appAttributes.autoValidateCustomerPost){
                cpView.proAuthPublish = true;
                cpView.timePublished =  new Date();
            }
            else{
                cpView.proAuthPublish = false;
                cpView.timePublished =  null;
            }
            cpView.updateModel($scope.onSaveSuccess);
        };

        $scope.addRatingByNotation = function(customerPost){
            if(customerPost.rating == 1){
                $scope.dd.nbRating.one ++;
            }
            else if(customerPost.rating == 2){
                $scope.dd.nbRating.two ++;
            }
            else if(customerPost.rating == 3){
                $scope.dd.nbRating.three ++;
            }
            else if(customerPost.rating == 4){
                $scope.dd.nbRating.four ++;
            }
            else if(customerPost.rating == 5){
                $scope.dd.nbRating.five ++;
            }
        }

        $scope.getAverageRating = function(){
            var nbRate = 0;
            var totalRate = 0;
            $scope.dd.nbRating.one = 0;
            $scope.dd.nbRating.two = 0;
            $scope.dd.nbRating.three = 0;
            $scope.dd.nbRating.four = 0;
            $scope.dd.nbRating.five = 0;

            for (var i = 0; i < $scope.dd.customersPostsDisplay.length; i++) {
                if(!$scope.dd.customersPostsDisplay[i].proAuthPublish){
                    continue;
                }
                if(isNaN($scope.dd.customersPostsDisplay[i].rating))
                    totalRate+=0;
                else {
                    totalRate += $scope.dd.customersPostsDisplay[i].rating;
                    $scope.addRatingByNotation($scope.dd.customersPostsDisplay[i]);
                }
                nbRate++;
            }
            if(nbRate > 0){
                $scope.dd.percent.one = Math.round(($scope.dd.nbRating.one * 100 / nbRate) * 100) / 100;
                $scope.dd.percent.two = Math.round(($scope.dd.nbRating.two * 100 / nbRate) * 100) / 100;
                $scope.dd.percent.three = Math.round(($scope.dd.nbRating.three * 100 / nbRate) * 100) / 100;
                $scope.dd.percent.four = Math.round(($scope.dd.nbRating.four * 100 / nbRate * 100)) / 100;
                $scope.dd.percent.five = Math.round(($scope.dd.nbRating.five * 100 / nbRate * 100)) / 100;
                $scope.dd.averageNotation = totalRate/nbRate;
            }
            $scope.dd.averageNotationDisplay = $filter('smartNumber')(($scope.dd.averageNotation), 2);
            $scope.dd.nbActiveRating = nbRate;
        };

        $scope.validateCustomerPost = function (customerPostView) {
            customerPostView.proAuthPublish = true;
            customerPostView.updateModel($scope.orderCustomersPost);

        };

        $scope.unValidateCustomerPost = function (customerPostView) {
            customerPostView.proAuthPublish = false;
            customerPostView.updateModel($scope.orderCustomersPost);

        };

        $scope.deleteCustomerPost = function (customerPostView) {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["label"] =  " " + gettextCatalog.getString("cet avis");

                        return tableModel;
                    }}};

            var d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                {
                    var index =  $scope.dd.customersPostsDisplay.indexOf(customerPostView);
                    if (index!=-1)
                    {
                        $scope.dd.customersPostsDisplay.splice(index, 1);
                    }
                    var index =  $scope.dd.customersPostsNeedValidation.indexOf(customerPostView);
                    if (index!=-1)
                    {
                        $scope.dd.customersPostsNeedValidation.splice(index, 1);
                    }
                    customerPostView.removeModel();
                    $scope.getAverageRating();
                }
            });

        };

        $scope.orderCustomersPost = function () {
            if($scope.dd.sortSelected.indexOf('.reverse') !== -1){
                $scope.dd.sortReverse = true;
                $scope.dd.sort = $scope.dd.sortSelected.replace('.reverse','');
            } else {
                $scope.dd.sortReverse = false;
                $scope.dd.sort = $scope.dd.sortSelected;
            }

            var customersPosts = CustomerPostData.getActiveList();
            $scope.dd.customersPostsNeedValidation= [];
            $scope.dd.customersPostsDisplay= [];
            for (var i = 0; i < customersPosts.length; i++) {
                let customerPost = customersPosts[i];
                if (customerPost.text) {
                    let customerPostView = new CustomerPostView(customerPost, CustomerPostData.getIndexOf(customerPost));

                    if (customerPostView.customer == null) {
                        customerPostView.customer = {};
                        customerPostView.customer.lastName = customerPostView.getModel().customerLastName;
                        customerPostView.customer.firstName = customerPostView.getModel().customerFirstName;
                    }
                    customerPostView.text = customerPostView.text.replace(new RegExp('\n', 'g'), '<br/>');
                    if (customersPosts[i].proAuthPublish) {
                        $scope.dd.customersPostsDisplay.push(customerPostView);
                    } else {
                        $scope.dd.customersPostsNeedValidation.push(customerPostView);
                    }
                }
            }
            $scope.getAverageRating();
        };

        $scope.clearPostView = function(){
            $scope.dd.view.postMessage = "";
            $scope.dd.view.postTitle = "";
            $scope.dd.view.postImage = null;
            $scope.dd.view.postRate = 0;
            $scope.dd.view.postImage = null;
            $scope.dd.error.display = false;
            $scope.dd.error.message = "";
            $scope.dd.displayPostMode = false
            $scope.dd.displayConfirmMessage = false
            $scope.dd.view.imageUploadRunning = false;
            $scope.dd.isWaitingForCallback = false;
            $scope.initTabRating();
        }

        $scope.onStarsClassChange = function (indexStar, isOnMouseOver) {
            if(!isOnMouseOver)
                indexStar = this.dd.view.postRate -1;
            for (let i = 0; i <= indexStar; i++) {
                $scope.dd.rating.starsClass[i] = $scope.dd.starYellowCssClass;
            }
            for (let i = indexStar+1; i < this.dd.rating.starsClass.length; i++) {
                $scope.dd.rating.starsClass[i] = $scope.dd.starGreyCssClass;
            }
        };

        $scope.onChangeRate = function (rate) {
            $scope.dd.view.postRate = rate;
            $scope.onStarsClassChange(rate-1);
        };

        $scope.onUploadImageSuccess = function(message)
        {
            $scope.dd.view.imageUploadRunning = false;
            try {
                var companyImage = JSON.parse(message);
                $scope.dd.view.postImage = companyImage;
                if (CompanyImageData.getById(companyImage.id) == null) {
                    CompanyImageData.add(companyImage);
                }
            } catch (e) {
                console.log('onUploadImageSuccess JSON.parse error', e);
            }
        };

        $scope.onUploadImageError = function(message)
        {
            $scope.dd.view.imageUploadRunning = false;
            $scope.dd.error.display = true;
            $scope.dd.error.message = gettextCatalog.getString("Impossible d'importer l'image sélectionnée.");
        };

        $scope.onStartUploadImage = function()
        {
            $scope.dd.view.imageUploadRunning = true;
        }

        $scope.canPost = function(){
            if($scope.dd.view.postTitle == null ||  $scope.dd.view.postTitle === "" ||
                $scope.dd.view.postMessage == null ||  $scope.dd.view.postMessage === "" ||  $scope.dd.view.postRate === 0 ||
                $scope.dd.view.imageUploadRunning){
                $scope.dd.error.display = true;
                return false;
            }
            $scope.dd.error.display = false;
            return true;
        }

        $scope.displayErrorMessage = function(){
            if($scope.dd.view.postTitle == null ||  $scope.dd.view.postTitle == ""||
                $scope.dd.view.postMessage == null ||  $scope.dd.view.postMessage == ""){
                $scope.dd.error.message = gettextCatalog.getString("Veuillez renseigner les champs obligatoires (Titre, Message).");
            }
            else if($scope.dd.view.imageUploadRunning == true){
               $scope.dd.error.message = gettextCatalog.getString("L'image est en cours de téléchargement, veuillez attendre la fin du téléchargement pour valider votre avis.");
            }
            else if($scope.dd.view.postRate === 0){
                $scope.dd.error.message = gettextCatalog.getString("Veuillez ajouter une note en cliquant sur une des étoiles avant de poster votre avis.");
            }
        }
    }
]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCustomerPostCtrl.js